import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'suffixConditionalWithDollar',
})
export class suffixConditionalWithDollarPipe implements PipeTransform {
 
  constructor(private currencyPipe: CurrencyPipe) { }
  transform(input: any, args?: any, ep?: any): any {
    let exp;
    const suffixes = ['K', 'M', 'B', 'T', 'P', 'E'];
    const isNagtiveValues = input < 0;

    if (Number.isNaN(input) || !this.isNumeric(input)) {
      return input;
    }

    if (Math.abs(input) < 10 && Math.abs(input) > 0) {
      return '$'+input.toFixed(args);
    } else {
      if (!isNagtiveValues) {
        if (ep == 0) {
          return '$'+this.currencyPipe.transform(input, ' ', '', '1.0-0');
        } else {
          exp = ep;
        }

        return '$'+(input / Math.pow(1000, exp)).toFixed(args) + suffixes[exp - 1];
      } else {
        input = input * -1;

        if (ep == 0) {
          return '$'+this.currencyPipe.transform(input*-1, ' ', '', '1.0-0');
        } else {
          exp = ep;
        }
        return '$'+(
          ((input * -1) / Math.pow(1000, exp)).toFixed(args) + suffixes[exp - 1]
        );
      }
    }
  }

  isNumeric(value): boolean {
    if (value < 0) value = value * -1;
    if (/^-{0,1}\d+$/.test(value)) {
      return true;
    } else if (/^\d+\.\d+$/.test(value)) {
      return true;
    } else {
      return false;
    }
  }
}